import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import FlatButton from 'material-ui/FlatButton'
import onboardingStyles from './styles/Sliders/Onboarding'
import missedApptStyles from './styles/Sliders/MissedAppointment'
import nextApptStyles from './styles/Sliders/NextAppointment'
import customStyles from './styles/Sliders/Custom'
import altCustomStyles from './styles/Sliders/CustomPost'
import createSlider from './CreateSlider'
import Help from './Help'
import HelpButton from './HelpButton'
import LoadingSpinner from '../sitewide/Spinner'
import styles from './styles/MessageSettings'
import AddSliderButton from './AddSliderButton'
import * as SettingsActions from '../../state/actions/message-settings'
import MessageSettingApptTypePicker from './MessageSettingApptTypePicker'
import SliderScale from './CreateSlider/SliderScale'
import { ATReduce, selectedApptTypesById } from './utils'

const OnboardingSlider = createSlider('OnboardingSlider', onboardingStyles)
const MissedAppointmentSlider = createSlider(
  'MissedAppointmentSlider',
  missedApptStyles,
)
const NextAppointmentSlider = createSlider(
  'NextAppointmentSlider',
  nextApptStyles,
)
const RecallAppointmentSlider = createSlider(
  'RecallAppointmentSlider',
  nextApptStyles,
)
const PostRecallAppointmentSlider = createSlider(
  'postRecallAppointmentSlider',
  missedApptStyles,
)
const CustomAppointmentSlider = createSlider(
  'CustomAppointmentSlider',
  customStyles,
  altCustomStyles,
)

class MessageSettings extends Component {
  state = {
    open: false,
    deleteID: null,
    deleteHandle: null,
    isHelpOpen: false,
    isPostAppt: false,
    customOpen: false,
    customSliderType: '',
    creatingCustomReminders: [],
    searchTerm: '',
    selectedApptTypes: [],
    selectedPostApptTypes: [],
    tempSliderName: '',
  }

  updatePopoverState = isOpen => {
    this.props.togglePopover(isOpen)
  }

  toggleDialog = (isOpen, customSliderType = '') => {
    if (!customSliderType) {
      customSliderType = this.state.customSliderType
    }
    this.setState({
      customOpen: isOpen,
      isPostAppt: false,
      customSliderType,
    })
  }

  toggleHelp = () => {
    this.setState({ isHelpOpen: !this.state.isHelpOpen })
  }

  handleRemoveType = removeId => {
    const { selectedApptTypes, selectedPostApptTypes, isPostAppt } = this.state
    if (isPostAppt) {
      const filteredTypes = selectedPostApptTypes.filter(
        typeId => typeId !== removeId,
      )
      this.setState({ selectedPostApptTypes: [...filteredTypes] })
    } else {
      const filteredTypes = selectedApptTypes.filter(
        typeId => typeId !== removeId,
      )
      this.setState({ selectedApptTypes: [...filteredTypes] })
    }
  }

  handleAddType = addId => {
    const { selectedApptTypes, selectedPostApptTypes, isPostAppt } = this.state
    if (isPostAppt) {
      if (selectedPostApptTypes.includes(addId)) return
      this.setState({
        selectedPostApptTypes: [...selectedPostApptTypes, addId],
      })
    } else {
      if (selectedApptTypes.includes(addId)) return
      this.setState({
        selectedApptTypes: [...selectedApptTypes, addId],
      })
    }
  }

  handleChange = e => {
    this.setState({ tempSliderName: e.target.value })
  }

  handlePostCheck = e => {
    const { isPostAppt } = this.state
    // If someone has selected appointment types and toggles post or not clear out
    // selectedAppointments so you don't cause conflicts with other sliders
    this.setState({
      isPostAppt: !isPostAppt,
      selectedApptTypes: [],
      selectedPostApptTypes: [],
    })
  }

  handleSearch = e => this.setState({ searchTerm: e.target.value })

  createCustomSlider = (apptTypeArr, sliderName, customSliderType) => {
    const { createCustomMessageSetting, activeLocationId } = this.props
    const setting = {
      name: sliderName,
      appointment_type_ids: apptTypeArr,
      location_id: activeLocationId,
      is_post_appt: this.state.isPostAppt,
      for_recall: customSliderType === 'recall',
    }
    return createCustomMessageSetting(setting).then(() => {
      this.toggleDialog(false)
      this.setState({
        selectedApptTypes: [],
        selectedPostApptTypes: [],
        tempSliderName: '',
        customSliderType: '',
      })
    })
  }

  render() {
    const {
      appointmentTypes,
      appointmentTypesById,
      availableAppointmentTypeIds,
      availablePostAppointmentTypeIds,
      postAppointmentTypesById,
      byId,
      customMessageSettings,
      hasPlum,
      hasRemindersTier2,
      hasTopsRemindersPlus,
      isLoaded,
      isPopoverOpen,
      pmsType,
      pmsVersion,
      practiceName,
      username,
    } = this.props

    const {
      customOpen,
      customSliderType,
      isHelpOpen,
      searchTerm,
      selectedApptTypes,
      selectedPostApptTypes,
      tempSliderName,
      isPostAppt,
    } = this.state

    const availableAppointmentTypesById = appointmentTypes
      .filter(type => availableAppointmentTypeIds.includes(type.id))
      .reduce(ATReduce, {})

    const availablePostAppointmentTypesById = appointmentTypes
      .filter(type => availablePostAppointmentTypeIds.includes(type.id))
      .reduce(ATReduce, {})

    const isTops = process.env.REACT_APP_IS_TOPS

    const eligiblePmses = ['Cloud9', 'Dolphin', 'OrthoTracV2']
    const PostRecallsPractices = [
      'Rooster Grin Media',
      'Cloud9 Test Practice',
      'Cloud9 Sandbox',
      'Shirck Orthodontics',
    ]
    const customRecallsPractices = [
      'Rooster Grin Media',
      'Cloud9 Test Practice',
      'Cloud9 Sandbox',
      'Specialty Smile Partners, LLC',
      'Larson Orthodontics',
    ]
    const customPostsPractices = [
      'Rooster Grin Media',
      'Cloud9 Test Practice',
      'Cloud9 Sandbox',
      'Specialty Smile Partners, LLC',
      'Hannon Orthodontics',
      'Elate Orthodontics',
      'Shirck Orthodontics',
      'White Orthodontics',
      'Good Day Orthodontics',
      'Keyser Orthodontics',
      'CB Orthodontics',
    ]
    const customRecallsEligible =
      hasRemindersTier2 &&
      eligiblePmses.includes(pmsType) &&
      customRecallsPractices.includes(practiceName)
    const customPostsEligible =
      hasRemindersTier2 &&
      eligiblePmses.includes(pmsType) &&
      customPostsPractices.includes(practiceName)
    const postRecallsEligible = PostRecallsPractices.includes(practiceName)

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.toggleDialog(false)}
      />,
      <FlatButton
        label={isTops ? 'Ok' : 'Submit'}
        primary
        disabled={
          !(
            (selectedApptTypes.length || selectedPostApptTypes.length) &&
            tempSliderName.length
          )
        }
        onClick={() =>
          this.createCustomSlider(
            isPostAppt ? selectedPostApptTypes : selectedApptTypes,
            tempSliderName,
            customSliderType,
          )
        }
      />,
    ]
    const generateSettingsList = Object.keys(byId).reduce(
      (settings, setting) => {
        const settingData = byId[setting]
        if (settingData.custom_message_setting_id && settingData.active) {
          if (!settings.hasOwnProperty(settingData.custom_message_setting_id)) {
            settings[settingData.custom_message_setting_id] = []
          }
          settings[settingData.custom_message_setting_id].push(settingData)
        }
        return settings
      },
      {},
    )

    const hasCustomMessageSettings =
      customMessageSettings &&
      customMessageSettings.some(({ for_recall: forRecall }) => !forRecall)
    const hasCustomRecallMessageSettings =
      customRecallsEligible &&
      customMessageSettings &&
      customMessageSettings.some(({ for_recall: forRecall }) => forRecall)

    const customSliders = () => {
      if (hasCustomMessageSettings) {
        return customMessageSettings.reduce(
          (
            customSlidersArr,
            {
              appointment_types: sliderAppointmentTypes,
              id,
              name,
              for_recall: forRecall,
              is_post_appt: isPostAppt,
            },
          ) => {
            if (!forRecall) {
              customSlidersArr.push(
                <CustomAppointmentSlider
                  appointmentTypesById={appointmentTypesById}
                  postAppointmentTypesById={postAppointmentTypesById}
                  isNegative={!isPostAppt}
                  isPopoverOpen={isPopoverOpen}
                  isPostAppt={isPostAppt}
                  id={id}
                  key={id}
                  messageSettingType={isPostAppt ? 'custom_post' : 'custom'}
                  name="Custom"
                  selectedApptTypes={sliderAppointmentTypes}
                  availableAppointmentTypesById={availableAppointmentTypesById}
                  availablePostAppointmentTypesById={
                    availablePostAppointmentTypesById
                  }
                  availableAppointmentTypeIds={availableAppointmentTypeIds}
                  availablePostAppointmentTypeIds={
                    availablePostAppointmentTypeIds
                  }
                  sliderSettings={generateSettingsList[id] || []}
                  sliderName={name}
                  updatePopoverState={this.updatePopoverState}
                  xPosition={660}
                >
                  <SliderScale
                    styles={isPostAppt ? onboardingStyles : customStyles}
                    isPostAppt={isPostAppt}
                  />
                </CustomAppointmentSlider>,
              )
            }
            return customSlidersArr
          },
          [],
        )
      }
      return null
    }

    const customRecallSliders = () => {
      if (hasCustomRecallMessageSettings) {
        return customMessageSettings.reduce(
          (
            customRecallsArr,
            {
              appointment_types: sliderAppointmentTypes,
              id,
              name,
              for_recall: forRecall,
            },
          ) => {
            if (forRecall) {
              customRecallsArr.push(
                <CustomAppointmentSlider
                  appointmentTypesById={appointmentTypesById}
                  isNegative
                  isPopoverOpen={isPopoverOpen}
                  id={id}
                  key={id}
                  messageSettingType="custom_recall"
                  name="Custom Recall"
                  selectedApptTypes={sliderAppointmentTypes}
                  availableAppointmentTypesById={availableAppointmentTypesById}
                  availableAppointmentTypeIds={availableAppointmentTypeIds}
                  sliderSettings={generateSettingsList[id] || []}
                  sliderName={name}
                  updatePopoverState={this.updatePopoverState}
                  xPosition={660}
                >
                  <SliderScale styles={customStyles} />
                </CustomAppointmentSlider>,
              )
            }
            return customRecallsArr
          },
          [],
        )
      }
      return null
    }

    return (
      <div>
        {isLoaded ? (
          <div className="MessageSettings" style={styles.container}>
            <h1>Appointment Reminder Settings</h1>
            <div style={styles.helpButtonContainer}>
              <HelpButton onTouchTap={this.toggleHelp} />
            </div>
            {isHelpOpen && (
              <Help
                hasPlum={!!hasPlum}
                hasReviews={false}
                onlyVars={false}
                pmsType={pmsType}
                pmsVersion={pmsVersion}
              />
            )}
            <OnboardingSlider
              name="First Appointment"
              messageSettingType="onboarding"
              xPosition={154}
              isPostAppt
              isPopoverOpen={isPopoverOpen}
              updatePopoverState={this.updatePopoverState}
            >
              <SliderScale styles={onboardingStyles} isPostAppt />
            </OnboardingSlider>
            <NextAppointmentSlider
              name="Next Appointment"
              messageSettingType="reminder"
              xPosition={660}
              isNegative
              isPopoverOpen={isPopoverOpen}
              updatePopoverState={this.updatePopoverState}
            >
              <SliderScale styles={nextApptStyles} />
            </NextAppointmentSlider>
            <MissedAppointmentSlider
              name="Missed Appointment"
              isPostAppt
              messageSettingType="no_show"
              xPosition={154}
              isPopoverOpen={isPopoverOpen}
              updatePopoverState={this.updatePopoverState}
            >
              <SliderScale styles={missedApptStyles} isPostAppt />
            </MissedAppointmentSlider>
            <RecallAppointmentSlider
              name="Recall"
              messageSettingType="recall"
              xPosition={660}
              isNegative
              isPopoverOpen={isPopoverOpen}
              updatePopoverState={this.updatePopoverState}
            >
              <SliderScale styles={nextApptStyles} />
            </RecallAppointmentSlider>
            {postRecallsEligible && (
              <PostRecallAppointmentSlider
                name="Post Recall"
                messageSettingType="recall"
                isPostAppt
                isWeeks={true}
                xPosition={154}
                isPopoverOpen={isPopoverOpen}
                updatePopoverState={this.updatePopoverState}
              >
                <SliderScale styles={missedApptStyles} isPostAppt isWeeks/>
              </PostRecallAppointmentSlider>
            )}
            {(hasRemindersTier2 || hasTopsRemindersPlus) && (
              <div>
                <h1>Custom Reminder Settings</h1>
                {customSliders()}
                <AddSliderButton
                  isDisabled={
                    !availableAppointmentTypeIds.length && !hasRemindersTier2
                  }
                  toggleDialog={this.toggleDialog}
                />
              </div>
            )}
            {customRecallsEligible && (
              <div>
                <h1>Custom Recall Reminder Settings</h1>
                {customRecallSliders()}
                <AddSliderButton
                  isDisabled={false}
                  toggleDialog={this.toggleDialog}
                  forCustomRecalls
                />
              </div>
            )}
            <MessageSettingApptTypePicker
              actions={actions}
              customPostsEligible={customPostsEligible}
              customSliderType={customSliderType}
              handleAddType={this.handleAddType}
              handleChange={this.handleChange}
              handlePostCheck={this.handlePostCheck}
              isSlider
              handleRemoveType={this.handleRemoveType}
              handleSearch={this.handleSearch}
              listType="Appointment Types"
              open={customOpen}
              searchTerm={searchTerm}
              selectedTypes={
                isPostAppt ? selectedPostApptTypes : selectedApptTypes
              }
              showSliderNameInput
              sliderAppointmentTypes={
                isPostAppt
                  ? {
                      ...availablePostAppointmentTypesById,
                      ...selectedApptTypesById(
                        selectedPostApptTypes,
                        postAppointmentTypesById,
                      ),
                    }
                  : {
                      ...availableAppointmentTypesById,
                      ...selectedApptTypesById(
                        selectedApptTypes,
                        appointmentTypesById,
                      ),
                    }
              }
              sliderAppointmentTypeIds={
                isPostAppt
                  ? [
                      ...availablePostAppointmentTypeIds,
                      ...selectedPostApptTypes,
                    ]
                  : [...availableAppointmentTypeIds, ...selectedApptTypes]
              }
            />
          </div>
        ) : (
          <LoadingSpinner />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    user: { activeLocation, practiceName, username },
    auth: {
      hasPlum,
      hasRemindersTier2,
      hasTopsRemindersPlus,
      pmsType,
      pmsVersion,
    },
  },
  messageSettings: { isLoaded, idsByType, byId, customMessageSettings },
  appointmentTypes: { appointmentTypes },
}) => {
  let usedAppointmentTypeIds = []
  let availableAppointmentTypeIds = []
  let usedPostAppointmentTypeIds = []
  let availablePostAppointmentTypeIds = []
  if (customMessageSettings) {
    customMessageSettings.forEach(setting => {
      if (setting.is_post_appt) {
        usedPostAppointmentTypeIds = [
          ...usedPostAppointmentTypeIds,
          ...setting.appointment_types,
        ]
      } else {
        usedAppointmentTypeIds = [
          ...usedAppointmentTypeIds,
          ...setting.appointment_types,
        ]
      }
    })
    availableAppointmentTypeIds = appointmentTypes.reduce((acc, { id }) => {
      if (!usedAppointmentTypeIds.includes(id)) return [...acc, id]
      return acc
    }, [])
    availablePostAppointmentTypeIds = appointmentTypes.reduce((acc, { id }) => {
      if (!usedPostAppointmentTypeIds.includes(id)) return [...acc, id]
      return acc
    }, [])
  }
  const appointmentTypesById = appointmentTypes.reduce(ATReduce, {})
  const postAppointmentTypesById = appointmentTypes.reduce(ATReduce, {})
  const activeLocationId = activeLocation ? activeLocation.id : null
  return {
    activeLocationId,
    appointmentTypes,
    appointmentTypesById,
    availableAppointmentTypeIds,
    availablePostAppointmentTypeIds,
    byId,
    customMessageSettings,
    hasPlum,
    hasRemindersTier2,
    hasTopsRemindersPlus,
    idsByType,
    isLoaded,
    pmsType,
    pmsVersion,
    postAppointmentTypesById,
    practiceName,
    username,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...SettingsActions }, dispatch)

MessageSettings.propTypes = {
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  activeLocationId: PropTypes.string,
  appointmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      appointment_type_guid: PropTypes.string,
      practice_id: PropTypes.number,
      code: PropTypes.string,
      description: PropTypes.string,
      visibility: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      online_scheduling: PropTypes.bool,
    }),
  ),
  appointmentTypesById: PropTypes.objectOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  availableAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string),
  byId: PropTypes.objectOf(PropTypes.object),
  createCustomMessageSetting: PropTypes.func,
  customMessageSettings: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      created_at: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
      practice_id: PropTypes.number,
      updated_at: PropTypes.string,
    }),
  ),
  hasPlum: PropTypes.bool,
  hasRemindersTier2: PropTypes.bool,
  hasTopsRemindersPlus: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool,
  isPopoverOpen: PropTypes.bool.isRequired,
  pmsType: PropTypes.string,
  pmsVersion: PropTypes.number,
  practiceName: PropTypes.string,
  togglePopover: PropTypes.func.isRequired,
  username: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageSettings)



// WEBPACK FOOTER //
// ./src/components/Settings/MessageSettings.js